module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('nav', {
    staticClass: "navbar is-transparent"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/requestDemo' || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/login' || _vm.$route.path === '/onBoard' || _vm.$route.path === '/terms' || _vm.$route.path.indexOf('/onBoardMember') !== -1) ? false : true),
      expression: "($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/login' || $route.path==='/onBoard' || $route.path==='/terms' || $route.path.indexOf('/onBoardMember') !== -1)? false : true"
    }],
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar()
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sidebarOpen),
      expression: "!sidebarOpen"
    }],
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sidebarOpen),
      expression: "sidebarOpen"
    }],
    staticClass: "fa fa-times",
    staticStyle: {
      "font-size": "17.5px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1 || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/login' || _vm.$route.path === '/terms') ? true : false),
      expression: "($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1 || $route.path.indexOf('/resetPassword') !== -1|| $route.path==='/login' || $route.path==='/terms')? true : false"
    }],
    attrs: {
      "href": "http://www.changevu.com"
    }
  }, [_c('img', {
    staticClass: "sitelogo",
    attrs: {
      "src": require("../../assets/headerLogo.png"),
      "alt": "Site Logo"
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1 || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/login' || _vm.$route.path === '/terms') ? false : true),
      expression: "($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1 || $route.path.indexOf('/resetPassword') !== -1|| $route.path==='/login' || $route.path==='/terms')? false : true"
    }],
    attrs: {
      "href": "/#"
    }
  }, [_c('img', {
    staticClass: "company-logo",
    attrs: {
      "src": _vm.clientLogoSrc,
      "alt": "Site Logo"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/requestDemo' || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1) ? true : false),
      expression: "($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1)? true : false"
    }],
    staticClass: "navbar-burger burger",
    class: {
      'is-active': _vm.showOutNav
    },
    attrs: {
      "data-target": "navMenu"
    },
    on: {
      "click": function($event) {
        _vm.showOutNav = !_vm.showOutNav
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/requestDemo' || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/login' || _vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1 || _vm.$route.path === '/terms') ? false : true),
      expression: "($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/login' || $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1 || $route.path==='/terms')? false : true"
    }],
    staticClass: "navbar-burger burger",
    class: {
      'is-active': _vm.showNav
    },
    attrs: {
      "data-target": "navMenu"
    },
    on: {
      "click": function($event) {
        return _vm.userMenuToggle()
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/requestDemo' || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1 || _vm.$route.path === '/terms') ? true : false),
      expression: "($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1 || $route.path==='/terms')? true : false"
    }],
    staticClass: "navbar-menu outNavMenu",
    class: {
      'is-active': _vm.showOutNav
    },
    attrs: {
      "id": "navMenu"
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/requestDemo' || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/login' || _vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1 || _vm.$route.path === '/terms') ? false : true),
      expression: "($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/login' || $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1 || $route.path==='/terms')? false : true"
    }],
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.showNav
    },
    attrs: {
      "id": "navMenu"
    }
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('a', {
    staticClass: "upgradeLink",
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }, [_vm._v("\n            Upgrade to Pro\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-item has-dropdown",
    class: {
      'is-hoverable': _vm.hover
    },
    on: {
      "mouseover": function($event) {
        return _vm.addHover()
      },
      "mouseleave": function($event) {
        return _vm.removeHover()
      }
    }
  }, [_c('a', {
    staticClass: "navbar-link is-active"
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.userImageSrc,
      "alt": "User"
    }
  }), _vm._v(" \n            " + _vm._s(_vm.currentUserName) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "navbar-dropdown user-menu"
  }, [(_vm.$cookie.get('role') === 'superAdmin') ? _c('div', {
    staticClass: "navbar-item text-center"
  }, [_c('a', {
    attrs: {
      "href": "#/admin"
    }
  }, [_vm._v("ChangeVU Admin")])]) : _vm._e(), _vm._v(" "), (_vm.$cookie.get('role') === 'superAdmin') ? _c('hr', {
    staticClass: "navbar-divider"
  }) : _vm._e(), _vm._v(" "), (_vm.$cookie.get('role') === 'superAdmin' || _vm.$cookie.get('role') === 'companyAdmin') ? _c('div', {
    staticClass: "navbar-item text-center"
  }, [_c('a', {
    attrs: {
      "href": "#/teamInfo"
    }
  }, [_vm._v("Manage Team Member(s)")])]) : _vm._e(), _vm._v(" "), (_vm.$cookie.get('role') === 'superAdmin' || _vm.$cookie.get('role') === 'companyAdmin') ? _c('hr', {
    staticClass: "navbar-divider"
  }) : _vm._e(), _vm._v(" "), (_vm.$cookie.get('role') === 'superAdmin' || _vm.$cookie.get('role') === 'companyAdmin') ? _c('div', {
    staticClass: "navbar-item text-center"
  }, [_c('a', {
    attrs: {
      "href": "#/assessmentInfo"
    }
  }, [_vm._v("Manage Assessment")])]) : _vm._e(), _vm._v(" "), (_vm.$cookie.get('role') === 'superAdmin' || _vm.$cookie.get('role') === 'companyAdmin') ? _c('hr', {
    staticClass: "navbar-divider"
  }) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr', {
    staticClass: "navbar-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "navbar-item text-center"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Log Out")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "notification notificationModal",
    class: {
      isActive: _vm.modalOpen
    }
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upgrade.email),
      expression: "upgrade.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "email",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.upgrade.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.upgrade, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "additionalComment"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Additional Comments")]), _vm._v(" "), _c('div', {
    staticClass: "select",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upgrade.info),
      expression: "upgrade.info"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.upgrade, "info", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Information on")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "infoRiskLicense"
    }
  }, [_vm._v("Change Risk teams license")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "infoLicense"
    }
  }, [_vm._v("ChangeVU application license")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "changePlatform"
    }
  }, [_vm._v("ChangeVU platform")])])])]), _vm._v(" "), (_vm.upgrade.info) ? _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upgrade.message),
      expression: "upgrade.message"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Write something..."
    },
    domProps: {
      "value": (_vm.upgrade.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.upgrade, "message", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "buttons has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitUpgrade()
      }
    }
  }, [_vm._v("\n              Send\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('a', {
    attrs: {
      "href": "#/login"
    }
  }, [_vm._v("\n            Already have a free trial account?\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-item text-center"
  }, [_c('a', {
    attrs: {
      "href": "#/accountSetting"
    }
  }, [_vm._v("Account Settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "is-title has-text-centered has-text-primary"
  }, [_c('b', [_vm._v("Want to upgrade to the Pro version?")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("\n          Fully automated change risk and mitigation planning for teams\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          No limit on number of assessments\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          Create your unique implementation team success profile\n        ")])]), _vm._v(" "), _c('h5', {
    staticClass: "is-title"
  }, [_vm._v("\n        Enable teams to reduce change risk rapidly and more successfully.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-420b9613"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/Navbar.vue
// module id = 370
// module chunks = 5